const isEmptyArray = (array?: unknown): boolean => {
  return Array.isArray(array) && array?.length === 0;
};

export const removeEmptyArrays = <T extends Record<string, unknown | Array<unknown>>>(obj: T): T => {
  Object.keys(obj).forEach((key) => isEmptyArray(obj[key]) && delete obj[key]);
  return obj;
};
